<style lang="stylus">
    .fileview-menu-dropdown
        display none
        @media screen and (max-width: 1400px)
            display flex
        .fileview-menu-dropdown-text
            display flex
            font-size 14px
            color #017fff
            align-items center
            >img
                margin-left 4px
        .z-dropdown-selector
            z-index 10 !important
    .fileview-menu-underline
        @media screen and (max-width: 1400px)
            display none
</style>

<template>
    <div class="ed-fileview" @contextmenu.stop.prevent>
        <div class="fileview-title">{{ activeTitle }}</div>
        <div class="fileview-menu">
            <MenuList class="fileview-menu-underline" v-model="menuId" :defaultId="0" :menuList="dataList" @toMenu="toMenu" />
            <div class="fileview-menu-dropdown">
                <Dropdown :data="dataList" @selectData="dropdownEvent">
                    <div class="fileview-menu-dropdown-text">
                        <p>{{ dataList[menuId].label }}</p>
                        <img :src="require(`@/home/assets/pcview/menuarr.svg`)" alt="" />
                    </div>
                </Dropdown>
            </div>
            <TopTool
                ref="topTool"
                :menuIndex="menuId"
                @changeSort="changeSort"
                @changeOrder="changeOrder"
                @applyOrderSort="applyOrderSort"
                @changeLayout="changeLayout"
                @toSearch="toSearch"
                @searchInput="searchInput"
                @clickNew="clickNew"
                @clickImport="clickImport"
                @clickTrashTool="clickTrashTool"
            />
        </div>

        <component class="fileview-container" :is="activeView" :ref="dataList[menuId].type" :type="dataList[menuId].type"></component>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "./parts/menu.vue";
    import TopTool from "./topTool.vue";
    import Cloud from "./view-cloud.vue";
    import Share from "./view-share.vue";
    import Collect from "./view-collect.vue";
    import Template from "./view-template.vue";
    import Publish from "./view-publish.vue";
    import Recycle from "./view-recycle.vue";
    import Dropdown from "../pcView/parts/Dropdown.vue";
    @Component({
        components: {
            MenuList,
            TopTool,
            Share,
            Collect,
            Template,
            Publish,
            Recycle,
            Dropdown,
        },
    })
    export default class Workbench extends Vue {
        menuId = 0;
        get dataList() {
            return [
                {
                    id: 0,
                    label: this.$t("files"),
                    type: "file",
                },
                {
                    id: 1,
                    label: this.$t("shares"),
                    type: "share",
                },
                {
                    id: 2,
                    label: this.$t("collect"),
                    type: "collect",
                },
                {
                    id: 3,
                    label: this.$t("template"),
                    type: "template",
                },
                {
                    id: 4,
                    label: this.$t("publishFile"),
                    type: "publishFile",
                },
                {
                    id: 5,
                    label: this.$t("recycle"),
                    type: "recycle",
                },
            ];
        }
        get activeTitle() {
            return this.dataList[this.menuId].label;
        }
        get activeView() {
            let obj = {
                0: Cloud,
                1: Share,
                2: Collect,
                3: Template,
                4: Publish,
                5: Recycle,
            };
            return obj[this.menuId];
        }
        get activeRef() {
            return this.$refs[this.dataList[this.menuId].type] as any;
        }
        dropdownEvent(e) {
            this.menuId = e;
            this.$nextTick(() => {
                this.toMenu(e);
            });
        }
        toMenu(e) {
            console.log(e);
            this.searchBack();
        }
        changeSort(data) {
            console.log(this.activeRef);
            this.activeRef.setOrder(data);
        }
        changeOrder() {
            this.activeRef.order();
        }
        applyOrderSort(order, sort) {
            this.activeRef.orderName = sort;
            this.activeRef.rotate = order;
        }
        changeLayout(data) {
            this.activeRef.setLayout(data);
        }
        searchMode = [false, false, false, false, false, false];
        toSearch(data) {
            if (data == "") {
                this.searchBack();
            } else {
                this.searchMode.splice(this.menuId, 1, true);
                this.activeRef.searchValue = data;
                this.activeRef.search();
            }
        }
        searchInput(data) {
            this.activeRef.searchValue = data;
        }
        searchBack() {
            (this.$refs.topTool as any).cleanSearch();
            this.searchMode.splice(this.menuId, 1, false);
            this.activeRef.searchBack();
        }
        clickNew(data) {
            if (data == 0) {
                this.sensors.track("newFile", {
                    Catalogues: "openFileProcess",
                    new_file_way: "myDocNew",
                    new_file_type: "emptyFile",
                });
                this.activeRef.toCreateFile();
            } else {
                this.activeRef.toCreateFolder();
            }
        }
        clickImport() {
            this.activeRef.showImportModal();
        }
        clickTrashTool(data) {
            if (data == "recover") {
                this.activeRef.recycleAllConfirm();
                // this.refreshStorage();
            } else if (data == "clear") {
                this.activeRef.recycleClearConfirm();
            }
        }
        mounted() {}

        created() {
            this.$store.commit("setState", { data: 1, type: "selectId" });
        }
    }
</script>
<i18n>
    {
      "zh": {
        "files": "我的文件",
        "shares": "我的分享",
        "collect": "我的收藏",
        "template": "我的模板",
        "shareToMe": "分享给我",
        "publishFile": "我的发布",
        "recycle": "回收站",
        "historyTips": "历史浏览可以看到最近打开的文件",
        "shareToMeTips": "其他用户分享给我的文件在这里能查看或编辑",
        "starTips": "新增星标文件功能啦~鼠标右键或者点击文件上的星标按钮将文件设置成星标后，将在此页面中展示",
        "confirm": "知道了"
      },
      "en": {
        "files": "My Documents",
        "shares": "My share",
        "collect": "My star",
        "template": "Personal Template",
        "shareToMe": "Shared with me",
        "publishFile": "Publish",
        "recycle": "Recycle bin",
        "historyTips": "History browsing can see the recently opened files",
        "shareToMeTips": "Files shared with me by other users can be viewed or edited here",
        "starTips": "Right-click or click the star button on the file to set the starred file, and all your starred files will be displayed on this page.",
        "confirm": "Know"
      },
      "fr": {
        "files": "Fichier cloud",
        "shares": "Mon partage",
        "collect": "ma collection",
        "template": "Modèle personnel",
        "shareToMe": "Partager avec moi",
        "publishFile": "Publier",
        "recycle": "Corbeille",
        "historyTips": "La navigation dans l'historique peut voir les fichiers récemment ouverts",
        "shareToMeTips": "Les fichiers partagés avec moi par d'autres utilisateurs peuvent être consultés ou modifiés ici",
        "starTips": "Une nouvelle fonction de fichier étoile a été ajoutée ~Cliquez avec le bouton droit de la souris ou cliquez sur le bouton étoile sur le fichier pour définir le fichier comme étoile et il apparaîtra sur cette page.",
        "confirm": "J'ai compris"
      },
      "de": {
        "files": "Cloud-Datei",
        "shares": "Mein Anteil",
        "collect": "meine Sammlung",
        "template": "Persönliche Vorlage",
        "shareToMe": "Teile mit mir",
        "publishFile": "Veröffentlichen",
        "recycle": "Papierkorb",
        "historyTips": "Beim Durchsuchen des Verlaufs werden die zuletzt geöffneten Dateien angezeigt",
        "shareToMeTips": "Von anderen Benutzern für mich freigegebene Dateien können hier angezeigt oder bearbeitet werden",
        "starTips": "Die neue Sternendateifunktion wurde hinzugefügt. Klicken Sie mit der rechten Maustaste oder klicken Sie auf die Sternschaltfläche in der Datei, um die Datei als Stern festzulegen. Danach wird der Stern auf dieser Seite angezeigt. ",
        "confirm": "Ich habs"
      },
      "jp": {
        "files": "クラウドファイル",
        "shares": "私の共有",
        "collect": "お気に入り",
        "template": "個人テンプレート",
        "shareToMe": "私との共有",
        "publishFile": "投稿",
        "recycle": "ゴミ箱",
        "historyTips": "閲覧履歴では、最近開いたファイルが表示されます。",
        "shareToMeTips": "他のユーザーが私と共有したファイルは、ここで表示または編集できます",
        "starTips": "ファイルを右クリックまたはスターボタンを押して、スターを追加できます。スターファイルはこのページで表示されます。",
        "confirm": "了解"
      },
      "es": {
        "files": "Archivo en la nube",
        "shares": "Mi parte",
        "collect": "mi colección",
        "template": "Plantilla personal",
        "shareToMe": "Compartido con",
        "publishFile": "Publicar",
        "recycle": "Papelera",
        "historyTips": "La exploración del historial puede ver los archivos abiertos recientemente",
        "shareToMeTips": "Los archivos compartidos conmigo por otros usuarios se pueden ver o editar aquí",
        "starTips": "Se agrega la nueva función de archivo con símbolo de estrella ~ Haz clic en el botón derecho o en el botón de símbolo de estrella en el archivo para establecerlo como una estrella, y se mostrará en esta página",
        "confirm": "Entiendo"
      },
      "pt": {
        "files": "Arquivo de nuvem",
        "shares": "Minha parte",
        "collect": "minha coleção",
        "template": "Modelo Pessoal",
        "shareToMe": "Compartilhe comigo",
        "publishFile": "Publicar",
        "recycle": "Pasta de Reciclagem",
        "historyTips": "A navegação no histórico pode ver os arquivos abertos recentemente",
        "shareToMeTips": "Os arquivos compartilhados comigo por outros usuários podem ser visualizados ou editados aqui",
        "starTips": " A função arquivo estrelado está agora disponível~ Clique com o botão direito do mouse ou clique no botão estrelado no arquivo para estrelar o arquivo, ele será exibido nesta página",
        "confirm": "Entendi"
      },
      "it": {
        "files": "File cloud",
        "shares": "Mia condivisione",
        "collect": "la mia collezione",
        "template": "Modello Personale",
        "shareToMe": "Condividi con me",
        "publishFile": "Pubblicare",
        "recycle": "Cestino",
        "historyTips": "La navigazione nella cronologia può vedere i file aperti di recente",
        "shareToMeTips": "I file condivisi con me da altri utenti possono essere visualizzati o modificati qui",
        "starTips": "La nuova funzione del file stella è stata aggiunta ~ Fare clic con il pulsante destro del mouse o fare clic sul pulsante Stella sul file per impostare il file come stella e verrà visualizzato in questa pagina.",
        "confirm": "Fatto"
      },
      "tw": {
        "files": "雲端硬碟檔案",
        "shares": "我的分享",
        "collect": "我的收藏",
        "template": "个人模板",
        "shareToMe": "分享給我",
        "publishFile": "我的發佈",
        "recycle": "回收站",
        "historyTips": "歷史瀏覽可以看到最近打開的檔案",
        "shareToMeTips": "其他用戶分享給我的檔案在這裡能查看或編輯",
        "starTips": "新增星標檔案功能啦~鼠標右鍵或者點擊檔案上的星標按鈕將檔案設置成星標後，將在此頁面中展示",
        "confirm": "知道了"
      },
      "kr": {
        "files": "클라우드 파일",
        "shares": "공유한 파일",
        "collect": "즐겨찾기",
        "template": "개인 템플릿",
        "shareToMe": "공유된 파일",
        "publishFile": "게시한 파일",
        "recycle": "휴지통",
        "historyTips": "조회 기록에서 최근 조회한 파일을 볼 수 있습니다",
        "shareToMeTips": "다른 사용자가 공유한 파일을 보거나 편집할 수 있습니다.",
        "starTips": "별을 추가하거나 파일의 별 버튼을 클릭하여 파일을 별표로 설정하면이 페이지에 표시됩니다.",
        "confirm": "알았다"
      },
      "id": {
        "files": "File cloud",
        "shares": "Berbagi saya",
        "collect": "Koleksi saya",
        "template": "Templat Pribadi",
        "shareToMe": "Bagikan dengan saya",
        "publishFile": "Terbitkan",
        "recycle": "Tempat sampah",
        "historyTips": "Penelusuran riwayat dapat melihat file yang baru dibuka",
        "shareToMeTips": "File yang dibagikan dengan saya oleh pengguna lain dapat dilihat atau diedit di sini",
        "starTips": "Klik kanan atau klik tombol bintang pada file untuk mengatur file berbintang, dan semua file berbintang akan ditampilkan di halaman ini.",
        "confirm": "Ketahuilah"
      }
    }
    </i18n>
